<template>
  <div class="text-center my-5">
    <h1>No Custom Reports Found</h1>
    <div class="mt-4">
      <b-button size="lg" variant="primary" @click="$emit('create')">
        <i class="fa fa-plus mr-2"/>
        Add Custom Report
      </b-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EmptyView'
  };
</script>

<style scoped>

</style>
